import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import './login.css';
import Util from '../util.js';
// import { getWebViewHtml } from '../action/webViewContentAction.js';
import { loginHXAssets, verifyRegisterPhone } from '../action/investmentAction.js';
import { Picker, List, Toast} from 'antd-mobile/lib';
// import { setStorage, goHome } from '../common';
import NavigatorMain from './NavigatorMain';
import { getTbuxyQis, getTbuxy } from '../action/loginAction.js';
import ModalList from "./Modal/ModalList"
let ToastTime = Util.ToastTime;
let encrypt = Util.encrypt;
let ua=navigator.userAgent.toLowerCase()
function getvl(name) {
    var reg = new RegExp("(^|\\?|&)"+ name +"=([^&]*)(\\s|&|$)", "i");
    if (reg.test(window.location.href)) return window.unescape(RegExp.$2.replace(/\+/g, " "));
    return undefined;
};
const seasons = [
    {
      label: '身份证',
      value: '0',
      key:0
    },
    {
      label: '护照',
      value: '1',
      key:1
    },
    {
      label: '军官证',
      value: '2',
      key:2
    },
    {
      label: '士兵证',
      value: '3',
      key:3
    },
    {
      label: '港澳居民来往内地通行证(原回乡证)',
      value: '4',
      key:4
    },
    {
      label: '户口本',
      value: '5',
      key:7
    },
    {
      label: '外国护照',
      value: '6',
      key:8
    },
    {
      label: '其他',
      value: '7',
      key:9
    },
    {
      label: '警官证',
      value: 'a',
      key:10
    },
    {
      label: '文职证',
      value: 'b',
      key:11
    },
    {
      label: '台胞证',
      value: 'A',
      key:12
    },
    {
      label: '基金账号',
      value: 'TAACCOUNTNO',
      key:13
    },
];


class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sValue:['0'],
      identityNumber:'',
      VerificationCode:'',
      passWord:'',
      enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
      invitationCode:this.props.location.query.inviteCode ? this.props.location.query.inviteCode : window.localStorage.getItem("inviteCode"),
      isShow:true,
      tanCar:false,
      Bools:false,
      contentVal:""
    };
    this.goCallback=false;
    this.hasCwimAccount=false;
  }
  goBack = () => {
    hashHistory.goBack();
  }
  componentWillMount(){
    document.title = "华夏基金账号登录"
  }
  componentDidMount(){

  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
  onChangeText(e){
    this.setState({
      identityNumber:e.target.value
    })
  }
  onChangePassWord(e){
    this.setState({
      passWord:e.target.value
    })
  }
  Verification(e){
    this.setState({
      VerificationCode:e.target.value
    })
  }
  onNext(){
    let {identityNumber,passWord } = this.state;
    if(identityNumber === ""){
      Toast.info("请输入证件号码",ToastTime)
    }else if(passWord === ""){
      Toast.info("请输入交易密码",ToastTime)
    } 
    let isIDCard15 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
    let isIDCard18 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
    if (this.state.sValue[0] === '0' &&identityNumber.length==15) { 
      Toast.info('只支持18位身份证登录，请在华夏基金进行身份证升位。',ToastTime) ;
      return;
    }
    if(this.state.sValue[0] === '0' && !(isIDCard15.test(identityNumber) || isIDCard18.test(identityNumber))){
      Toast.info('身份证号码不符合规则，请填写正确的号码',ToastTime) ;
      return;
    }

    let loginParam = {
      accountType: '1',//华夏基金1 华夏财富0
      certificateType: this.state.sValue[0],
      certificateNo: identityNumber.toUpperCase(),
      // password: CryptoJS.AES.encrypt('111aaa', 'chinaamc@app&web').toString()
      password: encrypt(passWord)
    }
    console.log(loginParam,"loginParamloginParamloginParam")
    this.props.dispatch(loginHXAssets(loginParam, (content)=>{this.loginSuccess(content),this.setState({contentVal:content})}, (msg)=>this.loginError(msg)));

  }
  loginSuccess(content){
    console.log(content)
    if (ua.indexOf("amcfmapp")>-1) {
      if (ua.indexOf("wkwebview")>-1) {
          if (window.webkit) {
            // Toast.info( '刷新', 3 );
            window.webkit.messageHandlers.amcfm_utils.postMessage({"refreshHome":"intelInvest"});
          }
      }else{
          if (window.amcfm_utils) {
            // Toast.info( '刷新', 3 );
            window.amcfm_utils.refreshHome('intelInvest');
          }
      }
    }
      if(content.hasCwimAccount){
        console.log(content)
        if(content.userId){
          if(content.certType == 0){
            this.props.dispatch(getTbuxy({clientType:"APP",token:""},(val)=>{
              console.log(val,"3939393939")
              if(val){
                this.goCallback=true;
                if(this.state.enterType ==="InviteRegister"){
                  // goHome("Investment");
                  hashHistory.replace({
                    pathname:'/?enterType=Investment' ,
                  })
                }else if(this.state.enterType ==="Answer"){
                  console.log("进入答题")
                  hashHistory.push({
                    pathname:'/AnswerActivityDatillPage',
                    state:{},
                    query: {enterType:"Answer",
                    activityId:this.props.location.query.activityId
                  }
                  })
                }else if(this.state.enterType == "activity"){
                    let resInfo = content;
                    let userId_a = resInfo.userId ? resInfo.userId : "";
                    let tradeAccountNo_a = resInfo.tradeAccountNo ? resInfo.tradeAccountNo : "";
                    let paramsStr = "userId=" +  userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
                    console.log(paramsStr)
                    let paramsData = window.encodeURIComponent(Util.aesEncrypt(paramsStr));
                    window.location.href = Util.hdUrl + paramsData
                }else{
                  this.isAppGo();
                }
              }else{
                this.setState({
                  tanCar: true
                })
              }
            }))
          }else{
            Toast.info('华夏财富仅支持身份证开户，详情请咨询客服',2) ;
          }
        }else{
          hashHistory.push({
            pathname: "/HxjjBindingMobile",
            query:{
              enterType:this.state.enterType,
            },
            state: {
              content: content,
              route: this.props.location.state.route,
              callback: this.props.location.state.callback,
              activityId:this.props.location.query.activityId
            }
          });
        }
      }else{
        if(content.certType == 0){
          if(content.mobileNo=="" || content.mobileNo==null || content.mobileNo==undefined){
            Toast.info('未能获取到您的手机号，请重试',2) ;
            return;
          }
          this.props.dispatch(verifyRegisterPhone({mobileNo: content.mobileNo}, ()=>{
            hashHistory.push({
              pathname:'/Loginkah',
              query:{},
              state:{
                name:content.name,
                loginType:content.certType,
                loginNo:content.certNo,
                mobileNo:content.mobileNo,
                callback:this.props.location.state.callback,
                route:this.props.location.state.route,
                _this:this.props,
                onFun:()=>{this.loginSuccess(content)}
              }
            })
          }, (msg)=>{Toast.info(msg,2);return},()=>{Toast.info("该手机号已被占用，如非本人操作，请联系我们",2);return})); 
        }else{
          Toast.info('华夏财富仅支持身份证开户，详情请咨询客服',2) ;
          return ;
        }
        // this.goCallback=true;
        // this.hasCwimAccount=true;//需要同步开户
        // this.isAppGo();
      }
  }
  isAppGo(){
    if (ua.indexOf("amcfmapp")>-1) {
      let enterType=getvl("enterType");
      if (enterType=='TransactionRecordProduct'||enterType=='InvestmentPlan') {
        hashHistory.replace({
          pathname: enterType,
        });
      }else{
        hashHistory.go(-1);
      }
    }else{
      if(this.state.enterType){
        hashHistory.go(-1);
      }else{ hashHistory.go(-2); }
    }
  }
  loginError(msg){
    console.log(msg,"登录失败")
    Toast.info(msg,ToastTime)
    // this.props.navigator.push({component: BindingMobile });
  }
  componentWillUnmount(){
    console.log(this.goCallback)
    if (this.goCallback) {
      if (this.hasCwimAccount) {
        hashHistory.push({
          pathname:'/BindingMobile',
          query:{
            enterType:this.state.enterType,
            invitationCode:this.state.invitationCode,
            activityId:this.props.location.query.activityId
          },
          state:{callback:this.props.location.state.callback,route:this.props.location.state.route}
        })
      }else{
       this.props.location.state.callback ? this.props.location.state.callback() : null
      }
    }
  }
  onKeyup(e){
    let {identityNumber,passWord } = this.state;
    if (identityNumber !== "" && passWord !== "" ) {
      e.keyCode === 13 && this.onNext();
    }
  }
  closeMoadl = ()=>{
    if(this.state.Bools){
      this.props.dispatch(getTbuxyQis({clientType:"APP",token:""},()=>{
        this.setState({
          tanCar:false
        })
        this.loginSuccess(this.state.contentVal)
      }))
    }else{
      Toast.info("请先阅读并确认用户同步信息授权书",2);
      return
    }
	}
  render(){
    let {identityNumber,passWord } = this.state;
    console.log(this.props.location.state)
    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={()=>this.goBack()}><span className="headerLeftBtn"></span></div>
              <div>华夏基金账号登录</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div className='content'>
            <div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 25, paddingBottom: 12}}>
              <div style={{fontSize: "13px", color: "#5b6370"}}>请输入您在华夏基金的账号和交易密码：</div>
            </div>
            <div className="pickerBox pickerBox_login" style={{
              display: "-webkit-flex",
              height: 45,
              backgroundColor: "#fff",
              paddingLeft: 13,
              paddingRight: 13,
              WebkitAlignItems: "center",
              WebkitFlexDirection: "row",
              borderBottom: "1px solid rgb(235, 238, 240)",
            }}>
              <Picker value={this.state.sValue}  onPickerChange={e => console.log('onPickerChange', e)} onOk={e =>  this.setState({ sValue:e }) } title="选择证件类型" data={seasons} cols={1} className="forss">
                <List.Item arrow="horizontal" >证件类型</List.Item>
              </Picker>
            </div>
            <div className='login-bar'>
              <span >
                证件号码
              </span>
              <input autocomplete="off"
              id='u2'
              value={this.state.identityNumber}
              onChange={(e)=>this.onChangeText(e)}
              placeholder="请输入证件号码"

              />
              <img onClick={()=>this.setState({identityNumber:''})} src={require('../img/login_input_cancel.png')}  className='imgBtn'  />
            </div>
            <div className='login-bar'>
              <span >
                交易密码
              </span>
              <input autocomplete="off"
              id='p2'
              type={this.state.isShow ?"password":"text"}
              value={this.state.passWord}
              onChange={(e)=>this.onChangePassWord(e)}
              placeholder="请输入交易密码"
              />
              <img alt="" onClick={()=>this.setState({isShow:!this.state.isShow})} style={{height: 30, width: 30}} src={ this.state.isShow ? require('../imgs/unshow_grey@3x.png') : require('../imgs/show_grey@3x.png')}/>
              <img onClick={()=>this.setState({passWord:''})} src={require('../img/login_input_cancel.png')}  className='imgBtn'  />
            </div>
            {
              identityNumber !== "" && passWord !== "" ?
              <div key={0}
              onClick={()=>this.onNext()}  className='btn'>
                <div >登录</div>
              </div> :
              <div className='btn btn-gray'
              key={0}
              >
                <div >登录</div>
              </div>
            }
          </div>
          <ModalList onFun={(Bools)=>{this.setState({Bools:Bools})}} flag={this.state.tanCar} btnRight={"确认"} btnRightFun={this.closeMoadl} content={"为了方便您在华夏财富系统和华夏基金系统同步办理业务，请您阅读并确认《用户同步信息授权书》"} title={""} />
        </div>
    ); 
  }
}



function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome:state.SupperFundHome,
  }
}
export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js